import { getGpBand, GP_BAND, parseGpPercent } from 'src/utils/recipeGp'
import {
  recipeHasNoPricesYet,
  recipeNeedsGpReview,
} from 'src/utils/recipeGpReview'

export const formatGpChangedFilterLabel = (label, count = 0) =>
  `${label} (${count})`

export const formatGpBandFilterLabel = formatGpChangedFilterLabel

export const GP_FILTER_CHANGED = 'gp_changed'

export const GP_CHANGED_FILTER_STYLE = {
  color: '#ad6800',
  backgroundColor: '#fff7e6',
}

export const GP_BAND_FILTER_OPTIONS = [
  { key: GP_BAND.GREEN, label: 'Green' },
  { key: GP_BAND.AMBER, label: 'Amber' },
  { key: GP_BAND.RED, label: 'Red' },
  { key: GP_FILTER_CHANGED, label: 'GP Changed' },
]

export const recipeMatchesGpBandFilter = (recipe, gpBandFilter) => {
  if (!gpBandFilter) {
    return true
  }

  if (gpBandFilter === GP_FILTER_CHANGED) {
    return recipeNeedsGpReview(recipe)
  }

  if (recipeHasNoPricesYet(recipe)) {
    return false
  }

  const gp = parseGpPercent(recipe?.grossProfit)
  const band = getGpBand(gp)
  return band.key === gpBandFilter
}

export const filterRecipesByGpBand = (recipes = [], gpBandFilter = null) => {
  if (!gpBandFilter) {
    return recipes
  }

  return recipes.filter(recipe =>
    recipeMatchesGpBandFilter(recipe, gpBandFilter),
  )
}

export const countRecipesByGpBand = (recipes = []) => {
  const counts = {
    [GP_BAND.GREEN]: 0,
    [GP_BAND.AMBER]: 0,
    [GP_BAND.RED]: 0,
    [GP_FILTER_CHANGED]: 0,
  }

  for (const recipe of recipes) {
    if (recipeNeedsGpReview(recipe)) {
      counts[GP_FILTER_CHANGED] += 1
    }

    if (recipeHasNoPricesYet(recipe)) {
      continue
    }

    const band = getGpBand(parseGpPercent(recipe?.grossProfit))
    if (Object.prototype.hasOwnProperty.call(counts, band.key)) {
      counts[band.key] += 1
    }
  }

  return counts
}

export const formatRecipePanelHeader = (label, count) => `${label} (${count})`
